module.exports = __webpack_public_path__ + "static/media/YF56_0.ce6144be.jpg";